window.addEventListener("load", () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    // Small delay ensures extremely fast networks still give users a smooth transition
    setTimeout(() => {
      preloader.classList.add("hidden");
      // Remove from DOM essentially after fade-out
      setTimeout(() => {
        preloader.style.display = "none";
      }, 800);
    }, 400);
  }
});
